import React from 'react'

interface State {
  hasError: boolean
  error?: Error | null
  info?: React.ErrorInfo | null
}

class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, State> {
  constructor(props: React.PropsWithChildren<{}>) {
    super(props)
    this.state = { hasError: false, error: null, info: null }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Log to console for developer visibility
    // In production, swap this for a logging endpoint
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught:', error, info)
    this.setState({ info })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 bg-red-900/20 border border-red-800 rounded-lg text-red-100">
          <h2 className="text-lg font-black mb-2">An error occurred rendering this view</h2>
          <p className="text-sm text-red-200 mb-4">Check the browser console for details.</p>
          {this.state.error && (
            <details className="text-xs text-red-300 whitespace-pre-wrap">
              {this.state.error.toString()}
              {this.state.info ? '\n\n' + this.state.info.componentStack : ''}
            </details>
          )}
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
